module.exports = __webpack_public_path__ + "img/upc-scan.78f24c4e.svg";